import { computed } from "vue";
import { useLanguageStore } from '../../pinia/LanguageStore';


export function translate(ident, parameters = {}) {
    const languageStore = useLanguageStore();
    let value = languageStore.__(ident, parameters);
    if (ident) {
                for (let i in parameters) {
                    value = value.replace(":" + i, parameters[i]);
                }
            }
        return value;
}
